<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Achievements Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newAchievement()">New Achievement</a>
					<a href="#" @click="saveAchievement()" v-if="achievement">Save</a>
					<a href="#" @click="deleteSelected()" v-if="achievement">Delete</a>
					<a href="#" @click="onLoad()" v-if="achievement">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="CMS Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>

		<b-modal id="modSure" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Really?">
			<p class="my-4">Are you sure?</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="success" @click="doDeleteSelected()">Yes</b-button>
				<b-button variant="danger" @click="cancel()">No</b-button>
			</template>
		</b-modal>

		<div class="row">
			<div class="col-md-3 mb-4">
				<h2>Achievements</h2>
				<div class="row mb-1" v-for="p in achievements" :key="p.id">
					<b-button @click="selectAchievement(p)">{{p.name}}</b-button>
				</div>
				<div class="row mb-1" v-if="achievement">
					<b-button @click="saveAchievement()" variant="primary"><b-icon-save font-scale="1.5"/> Save Current Achievement</b-button>
				</div>
				<div class="row mt-2 mb-1">
					<b-button @click="newAchievement()" variant="success"><b-icon-plus font-scale="1.5"/> New Achievement</b-button>
				</div>
				<div class="row mb-1" v-if="achievement">
					<b-button @click="deleteSelected()" variant="danger"><b-icon-trash font-scale="1.5"/> Delete Current Achievement</b-button>
				</div>
			</div>
			<div class="col-md-9" v-if="achievement">
				<div class="m-5 mt-0">
					<h2>{{achievement.name}}</h2>
					<div class="mb-2"><small>ID: {{achievement.id}}</small></div>
					Name: <b-form-input class="mb-2" v-model="achievement.name"></b-form-input>
					title: <b-form-input class="mb-2" v-model="achievement.title"></b-form-input>
					tagLine: <b-form-input class="mb-2" v-model="achievement.tagLine"></b-form-input>
					description: <b-form-input class="mb-2" v-model="achievement.description"></b-form-input>
					iconPath: <b-form-input class="mb-2" v-model="achievement.iconPath"></b-form-input>
					<div id="criteria">
						<b-button :title="c.description" class="btn-sm" v-for="c in criteria" :key="c.id" @click="psm.criteria += c.fact">{{c.fact}}</b-button>
					</div>
					Criteria: <b-form-input class="mb-2" v-model="achievement.criteria"></b-form-input>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Achievements',
  data() {
	return{
		achievements: null,
		achievement: null,
		message: null,
		error: null,
		criteria: null
	}
  },
  methods: {
	getAchievements: function(autoSelect){
		this.$http.get(this.$config.ApiUri + "/Achievements")
			.then((result) => {
				this.achievements = result.data;
				if (autoSelect) {
					if (this.achievements.length > 0) {
						this.achievement = this.achievements[0];
					}
				}
			}
		)
	},
	getCriteria: function(){
		this.$http.get(this.$config.ApiUri + "/Criteria")
			.then((result) => {
				this.criteria = result.data;
				this.criteria.shift();
				this.criteria.sort();
			}
		)
	},
	selectAchievement: function(p) {
		this.achievement = p;
	},
	saveAchievement: function(){
		if (this.achievement.id == null || this.achievement.id == "") {
			this.$http.post(this.$config.ApiUri + "/Achievements", this.achievement)
				.then((result) => {
					this.achievement = result.data;
					this.getAchievements(false);
					this.showMessage("Achievement created OK!");
				}
			).catch(() => { this.showError(); });
		}
		else {
			this.$http.put(this.$config.ApiUri + "/Achievements/" + this.achievement.id, this.achievement)
				.then((result) => {
					this.achievement = result.data;
					this.getAchievements(false);
					this.showMessage("Achievement saved OK!");
				}
			).catch(() => { this.showError(); });
		}
	},
	deleteSelected() {
		this.$bvModal.show('modSure');
	},
	doDeleteSelected() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/Achievements/" + this.achievement.id)
			.then(() => {
				this.achievement = null;
				this.getAchievements(true);
				this.showMessage("Achievement deleted OK!");
			}
		).catch((error) => { this.showError("Sorry, that Achievement cannot be deleted. This may mean Achievements have already been generated against it.  We cannot rewrite history. (" + error + ")"); });
	},
	newAchievement() {
		this.achievement = { 
			"id": "",
			"name": "",
			"title": "",
			"tagLine": "",
			"description": "",
			"iconPath": "",
			"criteria": "",
			"achievementCollectionID": "08da10cb-b930-463b-80ef-2bb2faf07da1"
		};
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tech"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.getAchievements(false);
		this.getCriteria();
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.modal-header .close {
  display:none;
}
#criteria .btn-sm {
	margin:3px;
	font-size:10px;
}
</style>